import { getItemSelected } from 'features/menu';
import { useSelector, useDispatch } from 'react-redux';
import { getUser, logout } from 'features/auth';
import { RootState } from 'features/store';


export const useSidebarVM = () => {
    const selectedItem = useSelector(getItemSelected);    
    const user = useSelector((state: RootState) => getUser(state));

    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logout());
    };

    return {
        selectedItem,
        user,
        handleLogout
    };
};
